export { default } from "./i18n";
